@if (!user) {
    <div class="custom-loader">
        <img src="assets/icons/allegion-horizontal-loading.png" alt="Custom Spinner">
    </div>
}
<!--Change to new component for tour guide-->
<restricted-product-tour-guide [showDialog]="showTourGuide"></restricted-product-tour-guide>
<restricted-product-support-button></restricted-product-support-button>

@if(user) {
    <router-outlet></router-outlet>
}
